export default function Toast({ message, onDismiss }) {
  if (!message) return null;
  return (
    <div className="fixed bottom-24 inset-x-0 z-50 flex justify-center px-4 pointer-events-none">
      <div onClick={onDismiss} role="status" className="pointer-events-auto animate-slide-up glass-sm px-5 py-2.5 text-sm font-medium text-gray-100 cursor-pointer">{message}</div>
    </div>
  );
}
